















import toTextClClass from '@/filters/to-text-cl-class'
import toFontSzClass from '@/filters/to-font-sz-class'
import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class ItemCardAction extends Vue {
  @Prop() title: string
  @Prop({default: 'click'}) act: string
  @Prop({default: false}) button: boolean
  @Prop({default: 'gray-800'}) color: string
  @Prop({default: 'subtitle'}) size: string

  get classes() {
    return [this.button ? 'is-button' : '', toTextClClass(this.color), toFontSzClass(this.size)]
  }

  get styles() {
    return this.color === 'primary'
      ? {
        marginRight: '8px',
        marginBottom: '8px',
      }
      : {
        marginTop: '0',
      }
  }

  onClick() {
    const {button, act} = this
    if(button) {
      this.$emit(act)
    }
  }
}
